import styled from "styled-components";

export const FilterContainer = styled.div`
  min-width: 340px;
  grid-area: fltr;
`

export const TreeContainer = styled.div`
  background: #fff;

  .ant-tree .ant-tree-switcher-noop {
    display: none;
  }
`

export const FilterLabel = styled.span`
  display: block;
  margin: 5px 0;
  font-size: 18px;
  font-weight: 700;
`
